import { render, staticRenderFns } from "./ruxiang.vue?vue&type=template&id=58c98a29&scoped=true&"
import script from "./ruxiang.vue?vue&type=script&lang=js&"
export * from "./ruxiang.vue?vue&type=script&lang=js&"
import style0 from "./ruxiang.vue?vue&type=style&index=0&id=58c98a29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c98a29",
  null
  
)

export default component.exports